package top.wcpe.allincore.dsl.compiler.ast

import top.wcpe.allincore.dsl.compiler.source.SourcePosition
import top.wcpe.allincore.dsl.compiler.source.SourceRange

/**
 * 所有 AST 节点的根接口。
 *
 * 通过 [position] 字段统一暴露源位置，便于诊断报告与 IR 调试。
 */
sealed interface AstNode {
    val position: SourcePosition

    /** 节点对应的源码范围；展开复制默认继承原节点位置。 */
    val range: SourceRange
        get() = position.range
}
